import NoImagePlaceholder from './favicon.png';
// './BrokenImage.svg';

export default {
    NoImagePlaceholder,
};
